import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Divider from '@mui/material/Divider';
import AccountPicker from './components/AccountPicker';
import ErrorDialog from './ErrorDialog';
import useSuspenseFetch from '../hooks/useSuspenseFetch';
import { useAuth0 } from '@auth0/auth0-react';

const SelectAccountDialog = () => {
    const { data: user } = useSuspenseFetch('user');
    const { emailAddress, accounts } = user;
    const { loginWithRedirect } = useAuth0();

    // todo handle message for invalid licence

    if (accounts.length > 0) {
        return (
            <Dialog open={true}>
                <DialogTitle>Select Account</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        You do not have an account selected. Please select an account you are invited to.
                    </DialogContentText>
                    <AccountPicker
                        accounts={accounts}
                    />
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button variant="contained" onClick={loginWithRedirect}>Sign Out</Button>
                </DialogActions>
            </Dialog>
        );
    }

    // todo create account process could come in here

    return (
        <ErrorDialog
            message={`Your email address ${emailAddress} has not been invited to a NewZapp account.`}
        />
    );
};

export default SelectAccountDialog;